'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypeDesc = getTypeDesc;
exports.ElementOfType = ElementOfType;
exports.ElementsOfType = ElementsOfType;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isElementOfType(element, type) {
  var result = false;
  if (Array.isArray(type)) {
    result = type.indexOf(element.type) !== -1;
  } else {
    result = element.type === type;
  }
  return result;
}

function getTypeDesc(type) {
  var desc = '(Unknown)';
  if (typeof type === 'string') {
    desc = type;
  } else if (type && type.displayName) {
    desc = type.displayName;
  } else if (Array.isArray(type)) {
    desc = type.map(function (t) {
      return getTypeDesc(t);
    }).join(', ');
  }
  return desc;
}

function ElementOfType(types) {
  // eslint-disable-next-line no-unused-vars
  return function (props, propName, componentName, location) {
    if (!props) return null;
    var value = props[propName];
    if (!_react2.default.isValidElement(value)) {
      return new Error('Invalid prop `' + propName + '` supplied to ' + componentName + ', expected ' + 'single React element, received invalid or multiple React element(s)');
    }
    if (!isElementOfType(value, types)) {
      return new Error('Invalid prop `' + propName + '` supplied to ' + componentName + ', expected ' + ('element of type ' + getTypeDesc(types) + ', received `' + value.type + '`'));
    }
    return null;
  };
}

function ElementsOfType(types) {
  // eslint-disable-next-line no-unused-vars
  return function (props, propName, componentName, location) {
    if (!props) return null;
    var error = null;
    _react2.default.Children.forEach(props[propName], function (child) {
      if (error) return;
      if (!_react2.default.isValidElement(child)) {
        error = new Error('Invalid prop `' + propName + '` supplied to ' + componentName + ', expected ' + ('elements of type ' + getTypeDesc(types) + ', received invalid React element(s)'));
        return;
      }
      if (!isElementOfType(child, types)) {
        error = new Error('Invalid prop `' + propName + '` supplied to ' + componentName + ', expected ' + ('elements of type ' + getTypeDesc(types) + ', received `' + child.type + '`'));
      }
    });
    return error;
  };
}

ElementOfType.dontWrap = true;
ElementsOfType.dontWrap = true;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-utils/static-2.45/js/propTypes/ElementOfType.js
// module id = 197
// module chunks = 0